export default "__VITE_ASSET__Crzo67d9__"